import { type PostHog } from 'posthog-js';
import { AuthLocalStorageKeys } from '@store/auth';

const usePostHog = defineStore('posthog', () => {
    const postHog = ref<PostHog>();
    const { isWebApp } = useDevice();
    const featureFlags = reactive<Record<string, string | boolean>>({});
    const loadPromise = ref<Promise<unknown>>();

    const utmSource = computed(
        () => postHog.value?.persistence?.props?.utm_source
    );
    const loadPostHog = async () => {
        if (postHog.value) {
            return;
        }
        const { resolve, reject, promise } = Promise.withResolvers();
        loadPromise.value = promise;
        const abortTimer = setTimeout(() => {
            reject();
        }, 5 * 1000);

        const { posthog } = await import('posthog-js');
        postHog.value = posthog;
        postHog.value?.people.set({ environment: useRunEnv() });
        postHog.value.init('phc_6I9FuXTI7Hb789HOwDkGyeWf2TS4ExjOpc6PTZocxFm', {
            api_host: 'https://ph.mrbilit.ir',
            capture_pageview: false,
            autocapture: false,
            loaded: () => {
                const credentials = JSON.parse(
                    localStorage.getItem(AuthLocalStorageKeys.credentials) ||
                        '[]'
                );
                const index = +(
                    localStorage.getItem(
                        AuthLocalStorageKeys.selectedCredentialIndex
                    ) || '0'
                );
                postHog.value?.identify(
                    localStorage.loginUuid ||
                        credentials[index]?.uuid ||
                        localStorage.localUuid
                );
                useRouter().afterEach((to: any) => {
                    nextTick(() => {
                        /* Note:
                         * this might also be a good place to call posthog.register(...) in order to update your properties
                         * on each page view
                         */
                        trackPostHog('$pageview', {
                            $current_url: to.fullPath,
                            isWebApp: isWebApp.value,
                        });
                    });
                });
            }, // If you can already identify your user
        });
        postHog.value.onFeatureFlags((_val, flags) => {
            if (flags) {
                clearTimeout(abortTimer);
                Object.assign(featureFlags, flags);
            }
            resolve(true);
        });
        postHog.value.reloadFeatureFlags();

        return promise;
    };

    const trackPostHog = async (name: string, attrs?: Record<string, any>) => {
        await loadPromise.value;
        nextTick(() => {
            if (postHog.value) {
                postHog.value.capture(name, {
                    ...attrs,
                    isWebApp: isWebApp.value,
                });
            } else {
                throw new Error(`initial the postHog`);
            }
        });
    };

    return {
        loadPostHog,
        trackPostHog,
        loadPromise,
        featureFlags,
        postHog,
        utmSource,
    };
});

export { usePostHog };
